var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21874 0C3.90624 0 2.15624 0.96875 0.843738 2.90625C0.249988 3.78125 0.437488 4.96875 1.28124 5.625L2.43749 6.5C2.74999 6.75 3.18749 6.90625 3.59374 6.90625C3.24999 7.5 3.06249 8.15625 3.06249 8.90625V9.28125C3.06249 9.78125 3.24999 10.25 3.56249 10.5938C3.03124 11.1875 2.74999 11.9375 2.74999 12.75C2.74999 14.5625 4.18749 16 5.99999 16C7.78124 16 9.24999 14.5625 9.24999 12.75C9.24999 11.9375 8.93749 11.1875 8.40624 10.5938C8.68749 10.3125 8.87499 9.90625 8.90624 9.5C9.78124 8.96875 11.9062 7.96875 11.9062 5.1875C11.9062 2.25 9.06249 0 6.21874 0ZM5.99999 14.5C5.03124 14.5 4.24999 13.7188 4.24999 12.75C4.24999 11.8125 5.03124 11 5.99999 11C6.93749 11 7.74999 11.8125 7.74999 12.75C7.74999 13.7188 6.93749 14.5 5.99999 14.5ZM7.40624 9V9.28125C7.40624 9.53125 7.18749 9.75 6.93749 9.75H5.03124C4.78124 9.75 4.56249 9.53125 4.56249 9.28125V8.90625C4.56249 7.4375 5.65624 6.84375 6.49999 6.375C7.24999 5.96875 7.68749 5.6875 7.68749 5.15625C7.68749 4.4375 6.78124 3.96875 6.03124 3.96875C5.09374 3.96875 4.62499 4.4375 4.03124 5.21875C3.84374 5.40625 3.53124 5.46875 3.34374 5.28125L2.18749 4.4375C1.96874 4.28125 1.93749 3.96875 2.06249 3.75C3.06249 2.3125 4.28124 1.5 6.21874 1.5C8.24999 1.5 10.4062 3.09375 10.4062 5.1875C10.4062 7.9375 7.40624 8 7.40624 9Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.b76ecf5f46cccd647ce7e4ae54eeae84.svg";
export { ForwardRef as ReactComponent };